export function findConfigurationAttachmentsFromProperties(properties, standardProperty) {
    var _a;
    const property = properties[standardProperty];
    if (property == null) {
        return [];
    }
    const path = (_a = (property.isLanguageDependent ? property.name : property.value)) !== null && _a !== void 0 ? _a : "";
    const name = path.slice(path.lastIndexOf("/") + 1);
    return [
        {
            name: name,
            description: property.description,
            path,
        },
    ];
}
//# sourceMappingURL=findConfigurationAttachmentsFromProperties.js.map